package com.ervasstudio.tracoemovimento.components.custumcomponents

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.Cursor.Companion.Pointer
import com.varabyte.kobweb.compose.css.ObjectFit
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors.Black
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.objectFit
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.silk.components.graphics.Image
import kotlinx.browser.window
import org.jetbrains.compose.web.css.CSSSizeValue
import org.jetbrains.compose.web.css.CSSUnit

@Composable
fun SocialIcon(src: String, url: String, size: CSSSizeValue<CSSUnit.px>) {
    Image(
        src = src,
        modifier = Modifier
            .width(size)
            .objectFit(ObjectFit.Cover)
            .cursor(Pointer)
            .onClick { window.open(url, "_blank") }
            .color(Black),
    )
}